import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { Spinner } from '@ingrid/luterkort-react';

import { TrackingEventEnum } from '~src/main/hooks/useTracking';
import { usePendingShipmentUpsertQuery } from '~src/pages/settings/pending-shipment/queries';

import { useShipmentHydrateMutation } from '../mutations';
import { ShipmentUpsert } from '../types';
import { CreatePage } from './page';

export function PendingPage() {
  const [shipment, setShipment] = useState<ShipmentUpsert>();

  const { lookup_id } = useParams();
  const { data } = usePendingShipmentUpsertQuery({ lookup_id });

  const hydrateMutation = useShipmentHydrateMutation();

  useEffect(() => {
    async function init() {
      if (!shipment) {
        setShipment(await hydrateMutation.mutateAsync(data.upsertShipment));
      }
    }

    void (async () => {
      await init();
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (hydrateMutation.isIdle || hydrateMutation.isPending) {
    return <Spinner />;
  }

  return (
    <CreatePage
      onSuccessEvent={TrackingEventEnum.ShipmentCreateFromPendingCompleted}
      onErrorEvent={TrackingEventEnum.ShipmentCreateFromPendingFailed}
      onInitEvent={TrackingEventEnum.ShipmentCreateFromPendingStart}
      error={data.error ?? hydrateMutation.error?.message}
      shipment={shipment}
    />
  );
}
